<h2 mat-dialog-title>
  <ng-content select="[dialog-title]" />
</h2>

<mat-dialog-content>
  <ng-content select="[dialog-content]" />
</mat-dialog-content>

<mat-dialog-actions>
  <ng-content select="[dialog-actions]" />
</mat-dialog-actions>
